export const subdomainReduces = (state: string) => state || 'www';
